module.exports = __webpack_public_path__ + "static/media/comprobante.5c2798d6.pdf";